'use strict';

define('vb/private/vx/baseExtensionAdapter',[
  'vb/private/log',
  'vb/private/constants',
], (Log, Constants) => {
  const logger = Log.getLogger('/vb/stateManagement/vx/extensionAdapter', [
    // Register a custom logger
    {
      name: 'greenInfo',
      severity: 'info',
      style: 'green',
    },
  ]);

  class BaseExtensionAdapter {
    /**
     * @param  {String} registryUrl  the url of the extension manager
     */
    constructor(registryUrl) {
      this.log = logger;
      this.registryUrl = registryUrl;
      this.log.info('Loading extensions from', this.registryUrl);
    }

    /**
     * Return a promise to load the manifest given the extensionId.
     * @param  {String} extensionId the extension id
     * @return {Promise}            a promise that resolves to the manifest
     */
    loadManifest(extensionId) {
      return Promise.resolve().then(() => {
        if (!this.registryUrl) {
          this.log.info('No extension registry defined.');
        }

        if (!extensionId) {
          throw new Error('Cannot load extension, extension id is not defined');
        }

        return {};
      });
    }

    /**
     * Caches extensions given a manifest. Base implementation does no caching, subclasses (native or PWA),
     * should implement platform specific caching.
     *
     * @param {Object} manifest a manifest containing an array of extensions
     * @return {Promise<Object>} returns an object with the following properties
     *   manifest - the original manifest and
     *   cachedExtensions - the list of cached extensions
     */
    // eslint-disable-next-line class-methods-use-this
    cacheExtensions(manifest) {
      return Promise.resolve({ manifest, cachedExtension: undefined });
    }

    /**
     * returns a list of extensions that need to be downloaded. Base implementation does not provide any, subclasses
     *  (native or PWA), should provide specific implementation.
     *
     *  Note: loadManifest method must be called before invoking this method
     * @return {Promise<Array>}
     * @see loadManifest
     */
    // eslint-disable-next-line class-methods-use-this
    getExtensionsToDownload() {
      return Promise.resolve();
    }

    /**
     * Given an extension id and its base URL this function returns a mapping (object with properties/values)
     * to be used with requirejs like:
     * {
     *   'vx/manifestId': 'file://.../sources'
     * }
     * @param  {extensionId} the id of the extension
     * @param  {baseUrl} the base URL of the extension
     * @return {String} a mapping string
     */
    // eslint-disable-next-line class-methods-use-this
    buildMapping(extensionId, baseUrl) {
      const mapping = {};
      mapping[`${Constants.EXTENSION_PATH}${extensionId}`] = baseUrl;

      return mapping;
    }
  }

  return BaseExtensionAdapter;
});

